// removed by extract-text-webpack-plugin
module.exports = {"DropdownTiny":"_3xmWGs9VGw8uDB95T_i1BT","DropdownTinyChecked":"_1PSqcAHI0yzWM0ptPVIEcf _3xmWGs9VGw8uDB95T_i1BT","checkbox":"_3erjcQ8rB2TYnuDunqrc1b","icon":"d92AGkiAPaO9jbZp0S9Ft","iconArrow":"FQQ1S4PZ7CF5IizjzdiSg","content":"_38WHkIYpRaTc7BLDOXMNwu","label":"LglkHQIukuYUYyWjQr9GB","label-text":"_1yyNdZj6QvUoC_G8CPpLJk","label-icon":"_3eLXXNlfWhoUXjWGO2ObC5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownTiny/DropdownTiny.css
// module id = 263
// module chunks = 8